import { lookupApplication } from '../utilities/applications';

export interface ApplicationDestination {
  destinationHostname: string | null;
  applicationName: string;
}

const parseContinueUrl = (searchParams: URLSearchParams) => {
  const continueUrl = searchParams.get('continue');
  if (continueUrl) {
    try {
      return new URL(continueUrl);
    } catch {
      //
    }
  }
  return null;
};

export const getApplicationDestination = (searchParams: URLSearchParams) => {
  const applicationData = lookupApplication(searchParams);
  const continueUrl = parseContinueUrl(searchParams);
  const destinationHostname = (continueUrl && continueUrl.hostname) || null;

  if (applicationData) {
    if (
      applicationData.coreApplication === 'jira' ||
      applicationData.coreApplication === 'confluence'
    ) {
      return {
        destinationHostname,
        applicationName: applicationData.name,
      };
    }
    return {
      destinationHostname: null,
      applicationName: applicationData.name,
    };
  }

  return null;
};

export default getApplicationDestination;
